module.exports = __webpack_public_path__ + "71cdf60c94dafeaab225f642cf89d8f9.pdf";